import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { DialogTitle } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  titleText: {
    fontWeight: 700,
    color: "#245e9e",
  },
  resize: {
    padding: 9,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "rgb(28, 86, 150)",
    fontWeight: 800,
    marginRight: 10,
  },
  button: {
    width: 70,
    height: 35,
    textTransform: "capitalize",
    backgroundColor: "#245e9e",
  },
  imageContainer: {
    width: "89%",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  arrowStyle: {
    cursor: "pointer",
    backgroundColor: "transparent",
    paddingLeft: 10,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
    "&:hover": {
      backgroundColor: "#dedddd !important",
    },
  },
  disabledArrowStyle: {
    cursor: "default",
    color: "#bdbdbd",
    backgroundColor: "transparent",
    paddingLeft: 10,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
  },
  dialogTitle: {
    width: "98%",
    display: "flex",
    justifyContent: "center",
    fontWeight: 700,
  },
}));

const ImageViewDialog = (props) => {
  const classes = useStyles();
  const { handleClose, open, data } = props;
  const { selectImageObject = {} } = data;
  const imageUrl = selectImageObject.firstImageFileName
    ? `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${selectImageObject.firstImageFileName}`
    : "";
  const pageNoLabel = selectImageObject.pageNoLabel
    ? selectImageObject.pageNoLabel
    : "";
  let imageHeight = window.screen.height - 300;

  return (
    <div>
      <Dialog
        maxWidth={"xl"}
        fullWidth
        open={open}
        disableBackdropClick
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <div className={classes.dialogTitle}>
            {pageNoLabel && !isNaN(parseInt(pageNoLabel)) ? "Page No " : ""}{" "}
            {pageNoLabel}
          </div>
          <IconButton
            title="Close"
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.container}>
          {/* <div onClick={data.isBackArrowDisabled ? () => { } : () => onBackArrowClick()} style={{ paddingLeft: 15, paddingRight: 2, margin: 10 }} className={data.isBackArrowDisabled ? classes.disabledArrowStyle : classes.arrowStyle}><ArrowBackIosIcon fontSize='large' /></div> */}
          <div
            className={classes.imageContainer}
            style={{
              backgroundImage: `url(${imageUrl})`,
              height: imageHeight,
            }}
          />
          {/* <div onClick={data.isNextArrowDisabled ? () => { } : () => onNextArrowClick()} style={{ margin: 10 }} className={data.isNextArrowDisabled ? classes.disabledArrowStyle : classes.arrowStyle}><ArrowForwardIosIcon fontSize='large' /></div> */}
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
};

ImageViewDialog.propTypes = {
  handleClose: PropTypes.func,
  onNextArrowClick: PropTypes.func,
  onBackArrowClick: PropTypes.func,
  open: PropTypes.bool,
  downloadFile: PropTypes.func,
  data: PropTypes.object,
};

ImageViewDialog.defaultProps = {
  handleClose: (fn) => fn,
  downloadFile: (fn) => fn,
  onNextArrowClick: (fn) => fn,
  onBackArrowClick: (fn) => fn,
  open: false,
  data: {},
};

export default ImageViewDialog;
